// HL-12999: the dose notice's Paid Order properties. Kept apart from doseNotice.ts so the Care+ hook can
// import it without an import cycle.

/** Same product name treatment_selected reports. */
export const doseProductName = (title: string | undefined, dosageStr: string | undefined): string =>
  `${title ?? ""} ${dosageStr ?? ""}`.trim();

// Paid Order gets dose_notice_shown + selected_product through cart.options.experiments. Whether the notice
// showed is kept per tab, so a reload on /choose_plan still reports it.
const DOSE_NOTICE_SHOWN_KEY = "wlDoseNoticeShown";

type DoseNoticeVisit = { category: string; shown: boolean };

const readDoseNoticeVisit = (): DoseNoticeVisit | null => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(DOSE_NOTICE_SHOWN_KEY) ?? "null");
    return parsed && typeof parsed.category === "string" && typeof parsed.shown === "boolean" ? parsed : null;
  } catch {
    return null;
  }
};

const writeDoseNoticeVisit = (visit: DoseNoticeVisit) => {
  try {
    sessionStorage.setItem(DOSE_NOTICE_SHOWN_KEY, JSON.stringify(visit));
  } catch {}
};

/** The page offers the notice: Paid Order reports dose_notice_shown for it (false until it shows). */
export const startDoseNoticeVisit = (category: string) => {
  if (readDoseNoticeVisit()?.category !== category) writeDoseNoticeVisit({ category, shown: false });
};

export const markDoseNoticeShown = (category: string) => writeDoseNoticeVisit({ category, shown: true });

/** The Paid Order properties for the cart write; empty when the page did not offer the notice. */
export const getDoseNoticeCartExperiments = (category: string, selectedProduct: string): Record<string, string> => {
  const visit = readDoseNoticeVisit();
  if (visit?.category !== category) return {};
  return { dose_notice_shown: String(visit.shown), selected_product: selectedProduct };
};
